import { ValueOf } from 'type-fest';

export const EasyPayProvider = {
  토스페이: `TOSSPAY`,
  네이버페이: `NAVERPAY`,
  삼성페이: `SAMSUNGPAY`,
  애플페이: `APPLEPAY`,
  엘페이: `LPAY`,
  카카오페이: `KAKAOPAY`,
  페이코: `PAYCO`,
  SSG페이: `SSG`,
} as const;

export type EasyPayProvider = keyof typeof EasyPayProvider;

export type EasyPayProviderCode = ValueOf<typeof EasyPayProvider>;
